<template>
    <div>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-allowed-meal-form
            :company-id="companyId"
            :entity-id="allowedMealId"
        ></company-allowed-meal-form>
    </div>
</template>

<script>
import CompanyAllowedMealForm from '@/components/pages/companyAllowedMeals/Form'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import dirtyForm from '@/components/mixins/dirtyForm'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: { CompanyAllowedMealForm, CompanyRouteTabs },

    mixins: [dirtyForm, AuthMixin],

    props: {
        allowedMealId: {
            type: [String, Number],
            default: null,
        },
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
}
</script>
